// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"127":"gamelist","465":"crosscase"}[chunkId] + "." + {"127":"6dd25298","465":"8896438c"}[chunkId] + ".css";
};